import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';
import { cn } from '../../../lib/utils';
import {
    linkedRowClass,
    linkedNameClass,
    linkedMetaClass,
} from '../../ui-components/linkedItemStyles';
import { LinkedPolicyDTO } from '../../../services/apiService';

interface LinkedPolicyRowProps {
    policy: LinkedPolicyDTO;
    meta?: string;
}

export default function LinkedPolicyRow({
    policy,
    meta,
}: LinkedPolicyRowProps) {
    const { t } = useTranslation();
    return (
        <Link
            to={`/department-policies/${policy._id}`}
            className={cn(linkedRowClass, 'transition-colors hover:bg-accent')}
        >
            <FileText
                className="h-4 w-4 shrink-0 text-subtle-foreground"
                aria-hidden="true"
            />
            <span className={cn(linkedNameClass, 'text-blue')}>
                {policy.document_id?.title?.trim() ||
                    t('pickers.policies.unnamed')}
            </span>
            {meta && <span className={linkedMetaClass}>{meta}</span>}
        </Link>
    );
}
